var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2501 2.5C12.9712 2.5 13.6365 2.88821 13.9913 3.51602L16.4266 7.82553L20.6341 8.64867C21.367 8.79206 21.959 9.33192 22.1692 10.0486C22.3794 10.7653 22.1728 11.5394 21.6333 12.056L18.4332 15.1204L19.1735 20.2122C19.2809 20.9509 18.9681 21.6878 18.3621 22.1237C17.7562 22.5595 16.958 22.6216 16.2919 22.2848L12.2501 20.2411L8.20825 22.2848C7.54216 22.6216 6.74395 22.5595 6.138 22.1237C5.53205 21.6878 5.2192 20.9509 5.32659 20.2122L6.06689 15.1204L2.86679 12.056C2.32736 11.5394 2.1207 10.7653 2.33089 10.0486C2.54107 9.33192 3.13308 8.79206 3.86606 8.64867L8.0735 7.82553L10.5089 3.51602C10.8636 2.88821 11.5289 2.5 12.2501 2.5ZM9.36151 9.61146L4.25006 10.6115L8.19433 14.3885L7.30578 20.5L12.2501 18L17.1943 20.5L16.3058 14.3885L20.2501 10.6115L15.1386 9.61146L12.2501 4.5L9.36151 9.61146Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlined);
export default __webpack_public_path__ + "static/media/star_outlined.e6f69ba0b2d64e3666bca8e6d070928e.svg";
export { ForwardRef as ReactComponent };